import RequestHandler from "./RequestHandler";
import { getTimezoneoffset } from "../utils/DateHelper";

function DashboardAPI() {
    const baseDashboardAPI = "dashboard";

    async function getScansNumber(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/scans-number`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getActiveUsersNumber() {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/active-users-number`
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelsNumber(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/models-number`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getMeasurementsNumber(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/measurements-number`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getModelsStatus(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/models-status`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getMaterialsScans(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/materials-scans`,
                filters
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getScansPerLot(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/scans-per-lot`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScansPerMaterial(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/scans-per-material`,
                filters
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function getScansTrend(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/scans-trend`,
                {
                    ...filters,
                    timezoneOffset: getTimezoneoffset(),
                }
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function exportScansTrendXml(filters) {
        try {
            const result = await RequestHandler.post(
                `${baseDashboardAPI}/scans-trend/export-xml`,
                {
                    ...filters,
                    timezoneOffset: getTimezoneoffset(),
                }
            );
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getScansNumber,
        getActiveUsersNumber,
        getModelsNumber,
        getMeasurementsNumber,
        getModelsStatus,
        getMaterialsScans,
        getScansPerLot,
        getScansPerMaterial,
        getScansTrend,
        exportScansTrendXml,
    };
}

export default DashboardAPI();
